import React from 'react';
import SettingsManagement from '../components/SettingsManagement';

const SettingsManagementPage: React.FC = () => <SettingsManagement />;

export default SettingsManagementPage;
